import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'

export default function CreateDialog({openCreateModel, setOpenCreateModel, handleCreate}) {
    const user = JSON.parse(localStorage.getItem('user'))
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          modelName: "",
        },
      });

    return (
        <form>
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenCreateModel(false)} open={openCreateModel}>
                <DialogTitle id='dialog-title'>
                    Create Model
                </DialogTitle>
                <DialogContent>
                <TextField
                    id="modelName"
                    type="text"
                    margin="dense"
                    value={values.modelName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Model"
                />
                {errors.modelName && touched.modelName && (
                    <p className="error">{errors.modelName}</p>
                )}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => {
                            setOpenCreateModel(false)
                            values.modelName = ""
                        }}
                        variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => {
                            //create new color
                            handleCreate(values.modelName)
                            //reset color name value
                            values.modelName = ""
                        }}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}